export default "__VITE_ASSET__213303b6__"